import { createEnum } from "@redotech/zod/zod-enum";
import stripe from "stripe";
import * as z from "zod/v4";

const PAYMENT_INTENT_TYPES = [
  "label",
  "recovery",
  "hold",
  "upsell",
  "repair",
  "exchange_shipping",
  "adjustment",
] as const;
type PaymentIntentType = (typeof PAYMENT_INTENT_TYPES)[number];

export const PaymentIntentItemZodSchema = z.object({
  id: z.string(),
  type: createEnum(PAYMENT_INTENT_TYPES),
  payment_intent: z.any(),
  refund: z.any().optional(),
  amount_USD: z.number().optional(),
  amount_received_USD: z.number().optional(),
});
export interface PaymentIntentItem {
  id: string;
  type: PaymentIntentType;
  payment_intent: stripe.PaymentIntent;
  refund?: any;
  amount_USD?: number;
  amount_received_USD?: number;
}
